// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PUcUN","field":"styles_field__154Or","fieldCol":"styles_fieldCol__3EtZq","diffCol":"styles_diffCol__2sion","diff":"styles_diff__2MKMN"};